import React from 'react';
import ComparisonOverlay from './ComparisonOverlay';
import PropTypes from 'prop-types';
import { parseUrlForProductParams } from '../../../../../services/v2/productsService';

import tick from '../../../../../image/Icons/tick-a805fb.svg';

/**
 * IconComparisonTable.
 * Table for comparing items in a product package.
 *
 * @author  Manny
 * @param   {Boolean}     props.buyNow          Check if method is buyNow.
 * @param   {Array}       props.data            Product package's data.
 * @param   {Object}      props.industryPackage List of packages for the industry.
 * @param   {String}      props.type            Type of product package data.
 * @returns {JSX.Element} The component markup.
 */

const IconComparisonTable = ({ buyNow, data, industryPackage, type }) => {
  let { methodParam } = parseUrlForProductParams(location);
  let dataContent = null;
  const isCommercial = industryPackage['cityscope'] != null;
  const iconColumnWidth = industryPackage.lite || industryPackage.cordell_estimator_platinum_lite ? 'col-xs-6 text-center' : 'col-xs-3 text-center'

  const renderTitle = (key, title, description) => {
    return <>
      <div className="flex">
        <div className="column semi-bold title-column"id={key}>
          {title}
        </div>
        <div className="column tooltip-column text-right">
          {description && <ComparisonOverlay tooltip={description}/>}
        </div>
      </div>
    </>
  }
  if (data !== undefined) {
    dataContent = Object.keys(data)
      .filter(function (singlePackage) {
        let item = data[singlePackage];
        return item !== undefined && item !== null;
      })
      .map(function (singlePackage) {
      let item = data[singlePackage];
      return (
        <div className='row table-padding' key={item.key || singlePackage}>
          <div className={isCommercial ? 'col-xs-2' : 'col-xs-3'}>
            {renderTitle(`item_title_${item.key}`, item.title, item.description)}
          </div>
          {Object.keys(industryPackage)
            .filter(function (singlePackageData) {
              let subItem = industryPackage[singlePackageData];
              return !((buyNow || methodParam?.includes('buyNow')) && subItem.key === 'trial');
            })
            .map(function (singlePackageData) {
              let subItem = industryPackage[singlePackageData];
              return (
                <div className={iconColumnWidth} key={subItem.key || singlePackageData}>
                  {subItem.features[type] && subItem.features[type][item.key] === true && (
                    <img className="tick-margin" src={tick} alt='yes' />
                  )}
                  {subItem.features[type] && subItem.features[type][item.key] === 'Except VIC' && (
                    <div>
                      <img className="tick-margin" src={tick} alt='yes' />
                      <div style={{ fontSize: '10px', marginBottom: '-10px' }}>Except VIC</div>
                    </div>
                  )}
                  {subItem.features[type] &&
                    typeof subItem.features[type][item.key] === 'string' &&
                    subItem.features[type][item.key] !== 'Except VIC' && (
                      <span>{subItem.features[type][item.key]}</span>
                    )}
                  {subItem.features[type] && !subItem.features[type][item.key] && (
                    <span>
                      <i className='fa fa-minus tan-text' aria-hidden='true'></i>
                    </span>
                  )}

                  {/* If the value is an object */}
                  {subItem.features[type] &&
                    typeof subItem.features[type][item.key] == 'object' &&
                    subItem.features[type][item.key]?.default && <img className="tick-margin" src={tick} alt='yes' />}
                  {subItem.features[type] &&
                    typeof subItem.features[type][item.key] == 'object' && (
                      <span>{subItem.features[type][item.key]?.price}</span>
                    )}
                </div>
              );
            })}
        </div>
      );
    });
  }

  return <div>{dataContent}</div>;
};

IconComparisonTable.propTypes = {
  buyNow: PropTypes.bool,
  data: PropTypes.array.isRequired,
  industryPackage: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired
};

export default IconComparisonTable;
